import { observable, action } from "mobx";

class InstantStoreC {
  @observable loading = false;
  @observable modal = {};
  @observable modal2 = {};
  @observable scroll = null;

  @action setLoading(data) {
    this.loading = data;
  }
  @action setModal(data) {
    this.modal = data;
  }
  @action setModal2(data) {
    this.modal2 = data;
  }
  @action changeModal(data) {
    this.modal = { ...this.modal, ...data };
  }
  @action setScroll(data) {
    this.scroll = data;
  }
}

export const Store = new InstantStoreC();
